export function buildTestId(propName: string, name = '') {
  return `properties-item-${name ? `${name}-` : ''}${propName}`;
}
